import React from "react";
import { inject, observer } from 'mobx-react'
import FontAwesome from 'react-fontawesome';
import {Holdable, defineHold} from 'react-touch';
import {Button, ButtonGroup} from "reactstrap";
import {Link} from "react-router-dom";
import {Component} from "react/lib/ReactBaseClasses";
import CardListaStore from "../stores/CardListaStore";
import {extendObservable} from "mobx";
import TituloPaginaStore from "../stores/TituloPaginaStore";

@inject("store")
@observer
export default class TituloPagina extends Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.controller = this.props.store.tituloPaginaStore;
    }

    gerarBotoes() {
        const botoesMobile = [];

        this.controller.botoesMobile.map((botao, i) => {
            botoesMobile.push(
                <li className={"page-title-button"}>
                    <a key={i} title={botao.label} onClick={() => botao.acao()}>{botao.icone ? <FontAwesome name={botao.icone} /> : botao.label }</a>
                </li>
            )
        });

        return botoesMobile
    }

    render() {
        return (
            <div>
                {this.controller.titulo ? (
                <div>
                    <ul className="page-title-with-button">
                        <li>
                            <h3>{this.controller.titulo}</h3>
                        </li>
                        {this.appStore.width <= 768 && this.controller.botoesMobile && this.controller.botoesMobile.length > 0 &&
                            this.gerarBotoes()
                        }
                    </ul>
                </div>
                ) : (
                    <br />
                )}
            </div>
        )
    }
}
